import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect } from "react";

import { AvatarCustom } from "../../../components";
import { CloseIcon } from "../../../components/Icons";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { fromISOToFormatDatePlusDays } from "../../../utils/unix-timestamp";
import {
  useGetAutoRenewalPreference,
} from "../../../services/renewal-preference/renewal-preference.service";
import { useModal } from "../../../context/ModalContext";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";

const CancelUpcomingPlanRenewalSuccessModal = () => {
  const { closeModal, params } = useModal();
  const subscriptionId = params?.subscriptionId as string;
  const petId = params?.petId as string;
  const { preference } = useGetAutoRenewalPreference(subscriptionId);

  const { petList } = usePetStore();

  const petDetails = petList?.find((pet) => pet.id === petId);

  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.CANCEL_UPCOMING_PLAN_RENEWAL_SUCCESS_MODAL_SHOWN, {
      subscriptionId: subscriptionId,
      petId: petId,
      petName: petDetails?.name,
      planName: preference?.newPlanName,
      planType: preference?.newPlanType,
      planStartDate: preference?.newPlanStartDate,
    });
  }, []);

  return (
    <div className="h-full xl:w-[25rem]">
      <div className="flex justify-end">
        <CloseIcon
          onClick={handleClose}
          className="text-light-black cursor-pointer mt-1"
        />
      </div>
      <div className="flex flex-col gap-3 justify-center items-center h-[90%] text-center px-6">
        <AvatarCustom
          image={petDetails?.image}
          name={petDetails?.name}
          width={80}
          height={80}
          isWellnessMember={true}
        />
        <Typography className="font-semibold !text-2xl">
          <span className="capitalize">{petDetails?.name}</span>&apos;s TotalCare renewal has been cancelled.
        </Typography>
        <Typography variant="body1">
          The {preference?.newPlanName} renewal scheduled for{" "}
          {preference?.newPlanStartDate &&
            fromISOToFormatDatePlusDays(preference.newPlanStartDate, 1)} will not take effect.
        </Typography>
      </div>

      <Box className="!sticky !bottom-0 w-full pt-8">

        <Button variant="outlined" type="submit" onClick={handleClose}
          className="!normal-case !font-semibold !border !border-taupe-2 !bg-gray-3 !w-full">
          {!petDetails ? <CircularProgress color="inherit" size={20} /> :
            "Done"}
        </Button>
      </Box>
    </div>
  );
};

export default CancelUpcomingPlanRenewalSuccessModal;

